import { Link, useLocation } from "react-router-dom";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../../components/button/button.component";
import {ReactComponent as WarningIcon} from "../../../icons/warning.svg";
import { useEffect, useState } from "react";
import { MainBox } from "../../../theme/global.styles";
import MainLayout from "../../../Layouts/MainLayout";

const Error500 = ({error, reset}) => {
  return (
    <>
      <MainBox style={{ width: "100%", boxSizing: "border-box", height: 600, display: "flex", flexDirection: "column", justifyContent: "center", margin: "auto" }}>
        <WarningIcon width={96} height={96} style={{marginLeft: "auto", marginRight: "auto"}}/>
        <h1 style={{textAlign: "center"}}>Unexpected Server Error</h1>
        <br/>
        <h5 style={{textAlign: "center"}}>Unexpected error. Please report this issue to the site administrator.</h5>
        <br/>
        <h5>{error.stack || error}</h5>
        <Button as={Link} to={"/"} onClick={reset} style={{ margin: "auto" }}>
          Return to Homepage
        </Button>
      </MainBox>
    </>
  );
};

export default Error500;
